/* eslint-disable @typescript-eslint/explicit-module-boundary-types,@typescript-eslint/no-explicit-any */
export const createApiTag = (type: string, id: string | number): any => ({ type, id })

export const provideListTags =
  (tag: string, id: string) =>
  <T extends { id: number }>(data: T[] | undefined): any =>
    data ? [...data.map(({ id }) => createApiTag(tag, id)), createApiTag(tag, id)] : [createApiTag(tag, id)]
